export default __webpack_public_path__ + "static/media/3.86c22927.png";